export default __webpack_public_path__ + "static/bg_main_section-a1caf27710538052bb539cd1a3db461a.png";